import React, { useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { Practitioner } from "../../types";
import SelectField, { Props as SelectProps } from "../Shared/SelectField";
import Textarea, { Props as TextareaProps } from "../Shared/Textarea";
import Button, { Props as ButtonProps } from "../Shared/Button";
import { getScheduleByPractitionerId, updateScheduleByPractitionerId } from "../../services/practitioner";
import { RootState } from "../../state/store";
import { selectActivePractitioners } from "../appSlice";

export type Props = { practitioners: Practitioner[] };
const PractitionerSchedule: React.FC<any> = () => {
  const practitioners = useSelector<RootState, any>(selectActivePractitioners);

  const [practitionerId, setPractitionerId] = useState<string>("");
  const [schedule, setSchedule] = useState<string>("");
  const [isLoadingSchedule, setIsLoadingSchedule] = useState<boolean>(false);
  const [isUpdatingSchedule, setIsUpdatingSchedule] = useState<boolean>(false);
  const [notification, setNotification] = useState<{
    success: boolean;
    message: string;
  } | null>(null);

  const handleChangePractitioner = async (e: React.ChangeEvent<HTMLSelectElement>): Promise<void> => {
    setIsLoadingSchedule(true);
    if (!_.isNull(notification)) {
      setNotification(null);
    }
    const id: string = e.target.value;
    setPractitionerId(id);
    const { result, error } = await getScheduleByPractitionerId(id);
    if (error) {
      setIsLoadingSchedule(false);
      setNotification({ success: false, message: "Can't get schedule" });
      return;
    }
    setSchedule(result);
    setIsLoadingSchedule(false);
  };

  const handleChangeSchedule = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    if (!_.isNull(notification)) {
      setNotification(null);
    }
    setSchedule(e.target.value);
  };

  const handleClickUpdateSchedule = async (): Promise<void> => {
    setIsUpdatingSchedule(true);
    const { error } = await updateScheduleByPractitionerId(practitionerId, schedule);
    if (error) {
      setNotification({ success: false, message: "Can't update schedule" });
    } else {
      setNotification({
        success: true,
        message: "Update schedule successfully",
      });
    }
    setIsUpdatingSchedule(false);
  };

  const selectProps: SelectProps = {
    label: "Please select practitioner and add schedule description",
    value: practitionerId,
    options: practitioners.map((p: any) => ({
      label: `${p.firstName} ${p.lastName}`,
      value: p.practitionerId,
    })),
    onChange: handleChangePractitioner,
    isRequired: true,
  };

  const textareaProps: TextareaProps = {
    value: schedule,
    onChange: handleChangeSchedule,
    isLoading: isLoadingSchedule,
  };

  const buttonProps: ButtonProps = {
    text: "UPDATE SCHEDULE",
    isLoading: isUpdatingSchedule,
    onClick: handleClickUpdateSchedule,
  };

  return (
    <div className="columns">
      <div className="column is-half">
        <p className="menu-label">practitioner schedule</p>
        {!_.isNull(notification) && (
          <div
            className={`notification is-light is-size-7 is-radiusless ${
              notification.success ? "is-success" : "is-danger"
            }`}
          >
            {notification.message}
          </div>
        )}
        <SelectField {...selectProps} />
        {!_.isEmpty(practitionerId) && (
          <>
            <Textarea {...textareaProps} />
            <Button {...buttonProps} />
          </>
        )}
      </div>
    </div>
  );
};

export default PractitionerSchedule;
